// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__c9h3E","balanceDisclaimer":"posDashboard_balanceDisclaimer__28yA8"};